import * as React from "react";
import {Dispatch} from "redux";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {RootState} from "../../../store/reducer/root/RootState";
import {Option} from "ts-option";
import {connect} from "react-redux";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import SidebarConfig from "./SidebarConfig";
import Toast from "../../helper/Toast";
import {updateJobSidebarOrder} from "../../../store/action/sidebar/sidebar";

interface IDispatchProps {
	/**
	 * Update job sidebar order
	 * @param {string[]} sidebarOrder
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateJobSidebarOrder: (sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface ReduxProps {
	/**
	 * Job sidebar order.
	 */
	jobSidebarOrder: Option<string[]>;
}

type Props = IDispatchProps & ReduxProps;

class JobSidebarConfig extends React.Component<Props> {
	sidebarMap: { [key in JobSidebarItem]: string } = {
		BRAND: "Brand",
		PARTNER_BRAND: "Partner brand",
		JOB_CREATOR: "Job creator",
		SITE_ADDRESS: "Site address",
		CUSTOMER: "Customer",
		CUSTOMER_ADDRESS: "Customer address",
		PICKUP_DATE: "Pickup date",
		MERCHANT_BRANCH_LOCATION: "Merchant branch location",
		MERCHANT: "Merchant",
		MERCHANT_BRANCH_DROPDOWN: "Merchant branch dropdown",
		INSTALLATION_DATE: "Expected Completion Date",
		JOB_COMPLETE_DATE: "Job complete date",
		COLLECTION_CONFIRMED: "Collection confirmed",
		TAGS: "Tags",
		DESCRIPTION: "Description",
		TITLE: "Title",
		ASSETS_SERIAL_NUMBERS: "Asset serial numbers",
		JOB_TYPE: "Job type",
		WATCHERS: "Watchers",
		WARRANTY_REGISTRATION_STATUS: "Warranty registration status",
		CUSTOM_FIELDS: "Custom fields",
		JOB_INVOICE_PATH: "Invoice path"
	};

	render() {
		return (
			<SidebarConfig updateSidebarOrder={this.updateSidebarOrder}
						   pageTitle={'Job sidebar order'}
						   sidebarOrder={this.props.jobSidebarOrder}
						   sidebarMap={this.sidebarMap}/>
		);
	}

	updateSidebarOrder = (sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) =>
		this.props.updateJobSidebarOrder(sidebarOrder,
			() => {
				onSuccess();
				Toast.success("Job sidebar order updated", "Job sidebar order update");
			},
			(err) => {
				onFailure(err);
				notifyBugsnagAndShowToast(err, "Job sidebar order update failed");
			}
		);
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateJobSidebarOrder: (sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) => {
			dispatch(updateJobSidebarOrder(sidebarOrder, onSuccess, onFailure))
		}
	};
}

function mapStateToProps(state: RootState) {
	return {
		jobSidebarOrder: state.sidebarOrder.jobSidebarOrder
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobSidebarConfig)

export enum JobSidebarItem {
	BRAND = "BRAND",
	PARTNER_BRAND = "PARTNER_BRAND",
	JOB_CREATOR = "JOB_CREATOR",
	SITE_ADDRESS = "SITE_ADDRESS",
	CUSTOMER = "CUSTOMER",
	CUSTOMER_ADDRESS = "CUSTOMER_ADDRESS",
	PICKUP_DATE = "PICKUP_DATE",
	MERCHANT_BRANCH_LOCATION = "MERCHANT_BRANCH_LOCATION",
	MERCHANT = "MERCHANT",
	MERCHANT_BRANCH_DROPDOWN = "MERCHANT_BRANCH_DROPDOWN",
	INSTALLATION_DATE = "INSTALLATION_DATE",
	JOB_COMPLETE_DATE = "JOB_COMPLETE_DATE",
	COLLECTION_CONFIRMED = "COLLECTION_CONFIRMED",
	TAGS = "TAGS",
	DESCRIPTION = "DESCRIPTION",
	TITLE = "TITLE",
	ASSETS_SERIAL_NUMBERS = "ASSETS_SERIAL_NUMBERS",
	JOB_TYPE = "JOB_TYPE",
	WATCHERS = "WATCHERS",
	WARRANTY_REGISTRATION_STATUS = "WARRANTY_REGISTRATION_STATUS",
	CUSTOM_FIELDS = "CUSTOM_FIELDS",
	JOB_INVOICE_PATH = "JOB_INVOICE_PATH",
}
